import React, {useEffect, useState} from "react";
import {RootStateOrAny, useDispatch, useSelector} from "react-redux";
import {Constants} from "../constants/Constants";
import UsersManager from "../managers/UsersManager";
import {Accordion, AccordionDetails, AccordionSummary, Avatar, Button, Typography} from "@material-ui/core";
import AppColors from "../colors/AppColors";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import '../input.css';
import MaterialSnackBar from "../views/MaterialSnackBar";
import axios from "axios";
import EndPoints from "../net/EndPoints";
import RequestUtils from "../utils/RequestUtils";
import ExceptionUtils from "../utils/ExceptionUtils";
import Routes from "../constants/Routes";
import {Redirect} from "react-router-dom";

export default function Profile(props: any) {

    const [openSnack, setOpenSnack] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [snackSeverity, setSnackSeverity] = useState("error");
    const [userAccountDeleted, setUserAccountDeleted] = useState(false);
    // noinspection DuplicatedCode
    const [canLogOut, setCanLogOut] = useState(false);

    const loggedInUserString: string | undefined = useSelector((state: RootStateOrAny) => {
        let liveUserData = state.appReducer[Constants.LOGGED_IN_USER_DATA];
        if (!liveUserData) {
            liveUserData = UsersManager.getLoggedInUser() as string;
        }
        return liveUserData;
    });

    const loggedInUser = loggedInUserString ? JSON.parse(loggedInUserString) : undefined;

    const [withdrawalAddress, setWithdrawalAddress] = useState(loggedInUser["withdrawalAddress"]);
    const [email, setEmail] = useState(loggedInUser["email"]);
    const [username, setUsername] = useState(loggedInUser["username"]);
    const [password, setPassword] = useState(loggedInUser["password"]);
    const [newPassword, setNewPassword] = useState(loggedInUser["password"]);
    const [repeatNewPassword, setRepeatNewPassword] = useState(loggedInUser["password"]);
    const [changingWithdrawalAddress, setChangingWithdrawalAddress] = useState(false);
    const [changingEmailAddress, setChangingEmailAddress] = useState(false);
    const [changingPassword, setChangingPassword] = useState(false);
    const [changingUsername, setChangingUsername] = useState(false);
    const [enabling2FA, setEnabling2FA] = useState(false);
    const [closingAccount, setClosingAccount] = useState(false);

    const dispatch = useDispatch();

    const handleSnackClose = () => {
        setOpenSnack(false);
    }

    const handleWithdrawalAddressChange = (newValue: string | null) => {
        setWithdrawalAddress(newValue);
    }

    const handleEmailChange = (newValue: string | null) => {
        setEmail(newValue);
    }

    const handleUsernameChange = (newValue: string | null) => {
        setUsername(newValue);
    }

    const handlePasswordChange = (newValue: string | null) => {
        setPassword(newValue);
    }

    const handleNewPasswordChange = (newValue: string | null) => {
        setNewPassword(newValue);
    }

    const handleRepeatNewPasswordChange = (newValue: string | null) => {
        setRepeatNewPassword(newValue);
    }

    const changeWithdrawalAddress = () => {
        if (!password) {
            setSnackSeverity("error");
            setSnackMessage("Please enter your current password");
            setOpenSnack(true);
            return;
        }
        if (!withdrawalAddress) {
            setSnackMessage("Enter your new withdrawal address");
            setSnackSeverity("error")
            setOpenSnack(true);
            return;
        }
        setChangingWithdrawalAddress(true);
        let postData = {
            [Constants.WITHDRAWAL_ADDRESS]: withdrawalAddress,
            [Constants.PASSWORD]: password
        }
        axios.post(EndPoints.UPDATE_WITHDRAWAL_ADDRESS, postData, {
            headers: RequestUtils.getHeaders()
        }).then(response => {
            let responseData = response["data"];
            let updatedUserData = responseData["data"];
            let message = responseData["message"];
            UsersManager.saveLoggedInUser(JSON.stringify(updatedUserData))
            dispatch({
                type: Constants.LOGGED_IN_USER_DATA_CHANGED,
                payload: JSON.stringify(updatedUserData)
            });
            setChangingWithdrawalAddress(false);
            setSnackSeverity("success");
            setSnackMessage(message);
            setOpenSnack(true);
        }).catch(error => {
            setChangingWithdrawalAddress(false);
            setSnackSeverity("error");
            setSnackMessage(ExceptionUtils.getErrorMessage(error));
            setOpenSnack(true);
        });
    }

    const changeEmailAddress = () => {
        if (!password) {
            setSnackSeverity("error");
            setSnackMessage("Please enter your current password");
            setOpenSnack(true);
            return;
        }
        if (!email) {
            setSnackMessage("Enter your new email address");
            setSnackSeverity("error")
            setOpenSnack(true);
            return;
        }
        setChangingEmailAddress(true);
        let postData = {
            [Constants.EMAIL]: email,
            [Constants.PASSWORD]: password
        }
        axios.post(EndPoints.UPDATE_EMAIL_ADDRESS, postData, {
            headers: RequestUtils.getHeaders()
        }).then(response => {
            let responseData = response["data"];
            let updatedUserData = responseData["data"];
            let message = responseData["message"];
            UsersManager.saveLoggedInUser(JSON.stringify(updatedUserData))
            dispatch({
                type: Constants.LOGGED_IN_USER_DATA_CHANGED,
                payload: JSON.stringify(updatedUserData)
            });
            setChangingEmailAddress(false);
            setSnackSeverity("success");
            setSnackMessage(message);
            setOpenSnack(true);
        }).catch(error => {
            setChangingEmailAddress(false);
            setSnackSeverity("error");
            setSnackMessage(ExceptionUtils.getErrorMessage(error));
            setOpenSnack(true);
        });
    }

    const changeUsername = () => {
        if (!password) {
            setSnackSeverity("error");
            setSnackMessage("Please enter your current password");
            setOpenSnack(true);
            return;
        }
        if (!username) {
            setSnackMessage("Enter your new username");
            setSnackSeverity("error")
            setOpenSnack(true);
            return;
        }
        setChangingUsername(true);
        let postData = {
            [Constants.USERNAME]: username,
            [Constants.PASSWORD]: password
        }
        axios.post(EndPoints.UPDATE_USERNAME, postData, {
            headers: RequestUtils.getHeaders()
        }).then(response => {
            let responseData = response["data"];
            let updatedUserData = responseData["data"];
            let message = responseData["message"];
            UsersManager.saveLoggedInUser(JSON.stringify(updatedUserData))
            dispatch({
                type: Constants.LOGGED_IN_USER_DATA_CHANGED,
                payload: JSON.stringify(updatedUserData)
            });
            setChangingUsername(false);
            setSnackSeverity("success");
            setSnackMessage(message);
            setOpenSnack(true);
        }).catch(error => {
            setChangingUsername(false);
            setSnackSeverity("error");
            setSnackMessage(ExceptionUtils.getErrorMessage(error));
            setOpenSnack(true);
        });
    }

    const enable2FA = () => {
        if (!password) {
            setSnackSeverity("error");
            setSnackMessage("Please enter your current password");
            setOpenSnack(true);
            return;
        }
        setEnabling2FA(true);
        axios.post(EndPoints.UPDATE_2FA, {
            password: password
        }, {
            headers: RequestUtils.getHeaders()
        }).then(response => {
            let responseData = response["data"];
            let message = responseData["message"];
            setEnabling2FA(false);
            setSnackSeverity("success");
            setSnackMessage(message);
            setOpenSnack(true);
        }).catch(error => {
            setEnabling2FA(false);
            setSnackSeverity("error");
            setSnackMessage(ExceptionUtils.getErrorMessage(error));
            setOpenSnack(true);
        });
    }

    const changePassword = () => {
        if (!password) {
            setSnackSeverity("error");
            setSnackMessage("Please enter your current password");
            setOpenSnack(true);
            return;
        }
        if (!newPassword) {
            setSnackMessage("Enter your new password");
            setSnackSeverity("error")
            setOpenSnack(true);
            return;
        }
        if (!repeatNewPassword) {
            setSnackMessage("Repeat your new password");
            setSnackSeverity("error")
            setOpenSnack(true);
            return;
        }
        if (newPassword != repeatNewPassword) {
            setSnackMessage("Sorry, passwords do not match");
            setSnackSeverity("error")
            setOpenSnack(true);
            return;
        }
        setChangingPassword(true);
        let postData = {
            currentPassword: password,
            newPassword: newPassword
        }
        axios.post(EndPoints.UPDATE_PASSWORD, postData, {
            headers: RequestUtils.getHeaders()
        }).then(response => {
            let responseData = response["data"];
            let updatedUserData = responseData["data"];
            let message = responseData["message"];
            UsersManager.saveLoggedInUser(JSON.stringify(updatedUserData))
            dispatch({
                type: Constants.LOGGED_IN_USER_DATA_CHANGED,
                payload: JSON.stringify(updatedUserData)
            });
            setChangingPassword(false);
            setSnackSeverity("success");
            setSnackMessage(message);
            setOpenSnack(true);
        }).catch(error => {
            setChangingPassword(false);
            setSnackSeverity("error");
            setSnackMessage(ExceptionUtils.getErrorMessage(error));
            setOpenSnack(true);
        });
    }

    const closeAccount = () => {
        if (!password) {
            setSnackMessage("Enter your password");
            setSnackSeverity("error")
            setOpenSnack(true);
            return
        }
        setClosingAccount(true);
        axios.delete(EndPoints.CLOSE_ACCOUNT, {
            headers: RequestUtils.getHeaders()
        }).then(_response => {
            setClosingAccount(false)
            UsersManager.deleteLoggedInUser();
            setUserAccountDeleted(true);
        }).catch(error => {
            let errorMessage = ExceptionUtils.getErrorMessage(error);
            setSnackMessage(errorMessage);
            setSnackSeverity("error");
            setOpenSnack(true);
        });
    }

    useEffect(() => {
        if (userAccountDeleted) {
            UsersManager.deleteLoggedInUser();
            setCanLogOut(true);
        }
    }, [userAccountDeleted]);

    return <div style={{
        display: 'flex',
        marginTop: 50,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    }}>
        {
            canLogOut &&
            <Redirect to={Routes.DEFAULT}/>
        }
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
        }}>
            <Avatar
                style={{
                    width: 100,
                    height: 100,
                    fontSize: 40,
                    fontWeight: 600,
                    backgroundColor: AppColors.ACCENT_COLOR
                }}>
                {
                    loggedInUser ? loggedInUser.email.charAt(0).toUpperCase() : ""
                }
            </Avatar>

            <Accordion style={{
                marginTop: 30,
                marginLeft: 30,
                marginRight: 30,
                width: '100%'
            }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon style={{
                        color: 'white'
                    }}/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    style={{
                        background: 'linear-gradient(to bottom,#3192f3 5%,#005bb6 100%)',
                    }}>
                    <Typography style={{
                        fontSize: 14,
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center'
                    }} align={"center"}>CHANGE WITHDRAWAL ADDRESS</Typography>
                </AccordionSummary>
                <AccordionDetails style={{
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <input value={withdrawalAddress}
                           onChange={(event) => {
                               handleWithdrawalAddressChange(event.target.value)
                           }}
                           style={{
                               padding: 10,
                           }}/>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        marginTop: 10,
                        justifyContent: 'space-evenly',
                        alignItems: 'center',
                        border: '1px solid grey',
                    }}>
                        <Typography style={{
                            fontWeight: 600,
                            padding: 10,
                        }}>PASSWORD:</Typography>
                        <input value={password}
                               placeholder={"Enter your password"}
                               onChange={(event) => {
                                   handlePasswordChange(event.target.value)
                               }}
                               style={{
                                   padding: 10,
                                   border: `0.5px solid #dddddd`
                               }}/>
                    </div>
                    <Button
                        disabled={changingWithdrawalAddress}
                        onClick={changeWithdrawalAddress}
                        style={{
                            width: 200,
                            alignSelf: 'center',
                            padding: 10,
                            marginTop: 10,
                            color: 'white',
                            background: 'linear-gradient(to bottom,#3192f3 5%,#005bb6 100%)',
                        }}>CHANGE</Button>
                </AccordionDetails>
            </Accordion>
            <Accordion style={{
                width: '100%',
                marginTop: 30,
                marginLeft: 30,
                marginRight: 30,
            }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon style={{
                        color: 'white'
                    }}/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    style={{
                        background: 'linear-gradient(to bottom,#3192f3 5%,#005bb6 100%)',
                    }}>
                    <Typography style={{
                        fontSize: 14,
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center'
                    }} align={"center"}>CHANGE EMAIL ADDRESS</Typography>
                </AccordionSummary>
                <AccordionDetails style={{
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <input value={email}
                           onChange={(event) => {
                               handleEmailChange(event.target.value)
                           }}
                           style={{
                               padding: 10,
                           }}/>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        marginTop: 10,
                        justifyContent: 'space-evenly',
                        alignItems: 'center',
                        border: '1px solid grey',
                    }}>
                        <Typography style={{
                            fontWeight: 600,
                            padding: 10,
                        }}>PASSWORD:</Typography>
                        <input value={password}
                               placeholder={"Enter your password"}
                               onChange={(event) => {
                                   handlePasswordChange(event.target.value)
                               }}
                               style={{
                                   padding: 10,
                                   border: `0.5px solid #dddddd`
                               }}/>
                    </div>
                    <Button
                        disabled={changingEmailAddress}
                        onClick={changeEmailAddress}
                        style={{
                            width: 200,
                            alignSelf: 'center',
                            padding: 10,
                            marginTop: 10,
                            color: 'white',
                            background: 'linear-gradient(to bottom,#3192f3 5%,#005bb6 100%)',
                        }}>CHANGE</Button>
                </AccordionDetails>
            </Accordion>

            <Accordion style={{
                marginTop: 30,
                marginLeft: 30,
                marginRight: 30,
                width: '100%'
            }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon style={{
                        color: 'white'
                    }}/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    style={{
                        background: 'linear-gradient(to bottom,#3192f3 5%,#005bb6 100%)',
                    }}>
                    <Typography style={{
                        fontSize: 14,
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center'
                    }} align={"center"}>CHANGE USERNAME</Typography>
                </AccordionSummary>
                <AccordionDetails style={{
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <input value={username}
                           onChange={(event) => {
                               handleUsernameChange(event.target.value)
                           }}
                           style={{
                               padding: 10,
                           }}/>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        marginTop: 10,
                        justifyContent: 'space-evenly',
                        alignItems: 'center',
                        border: '1px solid grey',
                    }}>
                        <Typography style={{
                            fontWeight: 600,
                            padding: 10,
                        }}>PASSWORD:</Typography>
                        <input value={password}
                               placeholder={"Enter your password"}
                               onChange={(event) => {
                                   handlePasswordChange(event.target.value)
                               }}
                               style={{
                                   padding: 10,
                                   border: `0.5px solid #dddddd`
                               }}/>
                    </div>
                    <Button
                        disabled={changingUsername}
                        onClick={changeUsername}
                        style={{
                            width: 200,
                            alignSelf: 'center',
                            padding: 10,
                            marginTop: 10,
                            color: 'white',
                            background: 'linear-gradient(to bottom,#3192f3 5%,#005bb6 100%)',
                        }}>CHANGE</Button>
                </AccordionDetails>
            </Accordion>
            <Accordion style={{
                marginTop: 30,
                marginLeft: 30,
                marginRight: 30,
                width: '100%'
            }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon style={{
                        color: 'white'
                    }}/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    style={{
                        background: 'linear-gradient(to bottom,#3192f3 5%,#005bb6 100%)',
                    }}>
                    <Typography style={{
                        fontSize: 14,
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center'
                    }} align={"center"}>CHANGE PASSWORD</Typography>
                </AccordionSummary>
                <AccordionDetails style={{
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        marginTop: 10,
                        justifyContent: 'space-evenly',
                        alignItems: 'center',
                        border: '1px solid grey',
                    }}>
                        <Typography style={{
                            fontWeight: 600,
                            padding: 10,
                        }}>CURRENT PASSWORD:</Typography>
                        <input value={password}
                               placeholder={"Enter Current Password"}
                               onChange={(event) => {
                                   handlePasswordChange(event.target.value)
                               }}
                               style={{
                                   padding: 10,
                                   border: `0.5px solid #dddddd`
                               }}/>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        marginTop: 10,
                        justifyContent: 'space-evenly',
                        alignItems: 'center',
                        border: '1px solid grey',
                    }}>
                        <Typography style={{
                            fontWeight: 600,
                            padding: 10,
                        }}>NEW PASSWORD:</Typography>
                        <input value={newPassword}
                               placeholder={"Enter New Password"}
                               onChange={(event) => {
                                   handleNewPasswordChange(event.target.value)
                               }}
                               style={{
                                   padding: 10,
                                   border: `0.5px solid #dddddd`
                               }}/>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        marginTop: 10,
                        justifyContent: 'space-evenly',
                        alignItems: 'center',
                        border: '1px solid grey',
                    }}>
                        <Typography style={{
                            fontWeight: 600,
                            padding: 10,
                        }}>REPEAT NEW PASSWORD:</Typography>
                        <input value={repeatNewPassword}
                               placeholder={"Repeat New Password"}
                               onChange={(event) => {
                                   handleRepeatNewPasswordChange(event.target.value)
                               }}
                               style={{
                                   padding: 10,
                                   border: `0.5px solid #dddddd`
                               }}/>
                    </div>
                    <Button
                        disabled={changingPassword}
                        onClick={changePassword}
                        style={{
                            width: 200,
                            alignSelf: 'center',
                            padding: 10,
                            marginTop: 10,
                            color: 'white',
                            background: 'linear-gradient(to bottom,#3192f3 5%,#005bb6 100%)',
                        }}>CHANGE</Button>
                </AccordionDetails>
            </Accordion>

            <Accordion style={{
                marginTop: 30,
                marginLeft: 30,
                marginRight: 30,
                width: '100%'
            }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon style={{
                        color: 'white'
                    }}/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    style={{
                        background: 'linear-gradient(to bottom,#3192f3 5%,#005bb6 100%)',
                    }}>
                    <Typography style={{
                        fontSize: 14,
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center'
                    }} align={"center"}>2 FACTOR AUTHENTICATION</Typography>
                </AccordionSummary>
                <AccordionDetails style={{
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <Typography
                        align={"center"}
                        style={{
                            textAlign: 'center',
                            width: 200,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            color: 'black'
                        }}>Whenever you try to Log In, an OTP would would be sent to your email address. When you
                        provide the OTP sent to you, you would be allowed to log in</Typography>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        marginTop: 10,
                        justifyContent: 'space-evenly',
                        alignItems: 'center',
                        border: '1px solid grey',
                    }}>
                        <Typography style={{
                            fontWeight: 600,
                            padding: 10,
                        }}>PASSWORD:</Typography>
                        <input value={password}
                               placeholder={"Enter your password"}
                               onChange={(event) => {
                                   handlePasswordChange(event.target.value)
                               }}
                               style={{
                                   padding: 10,
                                   border: `0.5px solid #dddddd`
                               }}/>
                    </div>
                    <Button
                        disabled={enabling2FA}
                        onClick={enable2FA}
                        style={{
                            width: 200,
                            alignSelf: 'center',
                            padding: 10,
                            marginTop: 10,
                            color: 'white',
                            background: 'linear-gradient(to bottom,#3192f3 5%,#005bb6 100%)',
                        }}>ENABLE</Button>
                </AccordionDetails>
            </Accordion>
            <Accordion style={{
                marginTop: 30,
                marginLeft: 30,
                marginRight: 30,
                marginBottom: 20,
                width: '100%'
            }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon style={{
                        color: 'white'
                    }}/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    style={{
                        background: 'linear-gradient(to bottom,red 5%,red 100%)',
                    }}>
                    <Typography style={{
                        fontSize: 14,
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center'
                    }} align={"center"}>CLOSE YOUR ACCOUNT</Typography>
                </AccordionSummary>
                <AccordionDetails style={{
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <Typography
                        align={"center"}
                        style={{
                            textAlign: 'center',
                            width: 200,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            color: 'black'
                        }}>When you close your account we'll permanently delete your account from our servers and
                        databases</Typography>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        marginTop: 10,
                        justifyContent: 'space-evenly',
                        alignItems: 'center',
                        border: '1px solid grey',
                    }}>
                        <Typography style={{
                            fontWeight: 600,
                            padding: 10,
                        }}>PASSWORD:</Typography>
                        <input value={password}
                               placeholder={"Enter your password"}
                               onChange={(event) => {
                                   handlePasswordChange(event.target.value)
                               }}
                               style={{
                                   padding: 10,
                                   border: `0.5px solid #dddddd`
                               }}/>
                    </div>
                    <Button
                        disabled={closingAccount}
                        onClick={closeAccount}
                        style={{
                            width: 200,
                            alignSelf: 'center',
                            padding: 10,
                            marginTop: 10,
                            color: 'white',
                            background: 'linear-gradient(to bottom,red 5%,red 100%)',
                        }}>CLOSE ACCOUNT</Button>
                </AccordionDetails>
            </Accordion>
        </div>
        <MaterialSnackBar
            open={openSnack}
            onSnackClosed={handleSnackClose}
            message={snackMessage}
            severity={snackSeverity}/>
    </div>
}